import React from "react";
import PermissionDeviceTile from "./PermissionDeviceTile";
import {iFormattedReportPermissionData} from "../../../../shared/interfaces";

const RenderPermissionReportData = ({ displayName, devices, tags }: iFormattedReportPermissionData) => {
    return (
        <div className="permission-report-card">
            <h2 className="permission-report-title">{displayName}</h2>
            <h3 className="permission-report-subtitle">Devices</h3>
            <div className="permission-report-devices">
                {devices.map((device, deviceIndex) => (
                    <PermissionDeviceTile
                        name={device.name}
                        timezone={device.timezone}
                        color={device.color}
                        icon={device.icon}
                        key={deviceIndex}
                    />
                ))}
            </div>
            {tags.length > 0 && <h3 className="permission-report-subtitle">Tags</h3>}
            {tags.map((tag, tagIndex) => {
                if (tag.devices.length) {
                    return (
                        <div className="permission-report-tag" key={tagIndex}>
                            <h4 className="permission-report-tag-title">{tag.tag.name}</h4>
                            <div className="permission-report-tag-devices">
                                {tag.devices.map((device, deviceIndex) => (
                                    <PermissionDeviceTile
                                        name={device.name}
                                        timezone={device.timezone}
                                        color={device.color}
                                        icon={device.icon}
                                        key={deviceIndex}
                                    />
                                ))}
                            </div>
                        </div>
                    )
                }
                return (
                    <div className="permission-report-tag" key={tagIndex}>
                        <h4 className="permission-report-tag-title">{tag.tag.name}</h4>
                        <p>Tag doesn't have devices</p>
                    </div>
                );
            })}
        </div>
    );
};

export default RenderPermissionReportData;